import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.833 12.5v1.667h8.334V12.5H5.833zm-3.333 5h15v-1.667h-15V17.5zm0-6.667h15V9.167h-15v1.666zm3.333-5V7.5h8.334V5.833H5.833zM2.5 2.5v1.667h15V2.5h-15z" fill="#54585D" /></svg>);